import moduleConfig from './module-config';
import netsChatNew from './nets-chat-new';

export default angular
  .module('app.chat-new', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsChatNew', netsChatNew);
